const GRID_CONSTANTS = {
  GRID_OVERLAY_STATUS: {
    LOADING: {
      VALUE: 'LOADING',
      MESSAGE: 'Please wait while data is loading'
    },
    ERROR: {
      VALUE: 'ERROR',
      MESSAGE: 'Something went wrong'
    },
    NO_DATA: {
      VALUE: 'NO_DATA',
      MESSAGE: 'No data available'
    }
  },
  GRID_EVENT_TYPES: {
    FILTER_CHANGED: 'filterChanged',
  }
};

export default GRID_CONSTANTS;
